import './App.css';
import { CssVarsProvider } from '@mui/joy/styles';
import theme from './other/theme';
import Router from "./other/router";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <CssVarsProvider theme={theme} defaultMode="dark">
          <Router />
        </CssVarsProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
